import { jsx } from "react/jsx-runtime";
import { MainMenuProvider } from "./context/index.js";
import MainMenu from "./MainMenu.js";
const MainMenuWithContext = (mainMenuProps)=>/*#__PURE__*/ jsx(MainMenuProvider, {
        variant: "default",
        ...mainMenuProps,
        children: /*#__PURE__*/ jsx(MainMenu, {})
    });
const MainMenu_MainMenuWithContext = MainMenuWithContext;
export default MainMenu_MainMenuWithContext;
